import type { IconData } from '@stacksjs/iconify-core'

export const header4: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 4h4V1a1 1 0 1 1 2 0v8a1 1 0 1 1-2 0V6H2v3a1 1 0 1 1-2 0V1a1 1 0 1 1 2 0zm10.636 4.74H10V7.302l.06-.198l2.714-4.11h1.687v3.952h.538V8.74h-.538V10h-1.825zm.154-1.283V5.774l-1.1 1.683z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default header4
